var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assign from './assign';
import { register } from './factory';
import { Size } from './IText';
import Type from './Type';
function isIOptions(init) {
    return typeof init === 'object' && init !== null && typeof init.text === 'string';
}
function options(init) {
    return isIOptions(init) ? init : { text: `${ init }` };
}
export class Generic {
    constructor(init) {
        this.type = Type.Code;
        const _a = options(init), {text, size, copy} = _a, rest = __rest(_a, [
                'text',
                'size',
                'copy'
            ]);
        this.text = `${ text }`;
        this.size = size || Size.Normal;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.text.configurable = false;
        descriptors.size.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Code extends Generic {
}
export const klass = Code;
export default Code;
register(Type.Code, Code);    //# sourceMappingURL=Code.js.map
